import { render, staticRenderFns } from "./YFmingxi.vue?vue&type=template&id=126ed102&scoped=true&"
import script from "./YFmingxi.vue?vue&type=script&lang=js&"
export * from "./YFmingxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ed102",
  null
  
)

export default component.exports